import digitalData from "digital-data";
import { BUTTON_SUBMISSION, PRICING_BENEFITS } from "../constants";

export const priceBook = () => {
  const trackEvent = (event) => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };

  const priceBookEvents = {
    clickShopNow: ({ output }) => {
      const { category } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PRICING_BENEFITS}: shop now button: ${category}`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickRequestPackage: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PRICING_BENEFITS}: your selected package: request a package switch link`,
        },
      };
      trackEvent(DDOEvent);
    },
  };

  window.LIFE_CYCLE_EVENT_BUS.on("pricebook.click-shopnow", priceBookEvents.clickShopNow);
  window.LIFE_CYCLE_EVENT_BUS.on(
    "pricebook.click-requestpackage",
    priceBookEvents.clickRequestPackage
  );
};
